import { render, staticRenderFns } from "./CrudUsers-comp.vue?vue&type=template&id=3fa2c03c&scoped=true&"
import script from "./CrudUsers-comp.vue?vue&type=script&lang=js&"
export * from "./CrudUsers-comp.vue?vue&type=script&lang=js&"
import style0 from "./CrudUsers-comp.vue?vue&type=style&index=0&id=3fa2c03c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fa2c03c",
  null
  
)

export default component.exports